import { LogitudeToken } from "./LogitudeToken";

export class LogitudeTokens {
    Authentication: LogitudeToken;
    SecurityKey: LogitudeToken;
}